<template>
	<div class="booking">
        <!--v-row>
          <ExperimentTitle />
        </v-row-->
        <v-row>
            <v-col>
                <h5 v-if="$route.name =='experiment'" class='p-3 m-0 pb-0 '><span v-text="show_experiment_name"></span> (Room {{ parseInt($cookies.get("equipment_id").slice(-1)) + 1 }})</h5>
                <h5 v-else-if="$route.params.equipment_name" class='p-3 m-0 pb-0 '><span v-text="show_experiment_name"></span> (Room {{ parseInt($route.params.equipment_name[4]) + 1 }})</h5>
                <h5 v-else class='p-3 m-0 pb-0 '><span v-text="show_experiment_name"></span></h5>
            </v-col>
        </v-row>
        <v-card class="ma-4">
            <v-container>
            <v-row>
                <v-col cols="12" xs="12" sm="6" md="6" lg="4" class="my-2 px-1">
                <v-date-picker
                    class="ma-4"
                    ref="picker"
                    v-model="current_date"
                    full-width
                    @change="getSlotsByDate"
                ></v-date-picker>
                </v-col>
                <v-col cols="12" xs="12" sm="6" md="6" lg="8" class="my-2 px-1">
                <!-- <div class="title">{{$route.params.experiment_name}}</div> -->
                <!-- <div class="subheading">{{current_date}}</div> -->
                     <v-simple-table>
                        <template v-slot:default>
                        <thead>
                            <tr>
                            <th class="text-left">From</th>
                            <th class="text-left">To</th>
                            <th class="text-left">Room</th>
                            <th class="text-left">Action</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="(slot, index) in api.slots" :key="index">
                                <template v-if="slot.display">
                                <!-- <td><p v-if="index==0 || api.slots[index-1].start_at!=api.slots[index].start_at">{{ slot.start_at | moment("HH:mm") }}</p></td>
                                <td><p v-if="index==0 || api.slots[index-1].end_at!=api.slots[index].end_at">{{ slot.end_at | moment("HH:mm") }}</p></td> -->
                                <td><p>{{ slot.start_at | moment("HH:mm") }}</p></td>
                                <td><p>{{ slot.end_at | moment("HH:mm") }}</p></td>
                                <td>{{ slot.equipment_id | roomName }}</td>
                                <td>
                                    <v-btn  color="accent"
                                        v-if="slot.status=='IDLE'"
                                        @click="bookSlot(slot.id)"
                                    >Book</v-btn>
                                    <v-btn color="success"
                                        v-if="isBookedByMe(slot)"
                                        @click="enterLab(slot.id, slot.equipment_id, 'player')"
                                    >Enter Lab</v-btn>
                                    <v-btn color="info"
                                        v-if="isBookedByOthers(slot)"
                                        @click="enterLab(slot.id, slot.equipment_id, 'observer')"
                                        disabled
                                    >Reserved</v-btn>
                                    <v-btn color="amber darken-2 white--text"
                                        v-if="isBookedSoon(slot)"
                                        @click="releaseSlot(slot.id)"
                                    >Cancel Booking</v-btn>
                                </td>
                                </template>
                            </tr>
                        </tbody>
                        </template>
                    </v-simple-table>
                </v-col>
            </v-row>
            </v-container>
        </v-card>
	</div>
</template>
<script>
	import moment from 'moment';
    import {Booking_APIService} from '@/services/Booking_APIService';
    import ExperimentTitle from "@/components/ExperimentTitle.vue";
    const apiService = new Booking_APIService(process.env.VUE_APP_BASE_URL);
	export default {
		name: 'booking',
		components: {
      ExperimentTitle,
		},
        data: () => ({
            current_date: (new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString().slice(0, -1).substr(0, 10),
            api:{
                slots: [
                ],
                my_slots: [
                ]
            },
            show_experiment_name: "456",
        }),
        filters: {
            roomName: function (value) {
                switch (value){
                    case "set_0":
                    return "Room 1"
                    case "set_1":
                    return "Room 2" 
                    case "set_2":
                    return "Room 3" 
                    case "set_3":
                    return "Room 4" 
                    case "set_4":
                    return "Room 5" 
                }
            },
            labelExperiment: function (name) {
              switch(name){
                case "INTERFERENCE":
                   return "Interference";
                case "VISIBLE_SPECTRUM":
                    return "Visible Spectrum";
                case "APPARENT_DEPTH":
                    return "Apparent Depth";
                case "BACTERIA_GROWTH":
                    return "Bacteria Growth";
                case "EM_INDUCTION":
                    return "EM Induction";
                case "GREEN_HOUSE":
                    return "Green House";
                case "PHOTO_ELECTRIC":
                    return "Photo Electric";
                case "RADIATION":
                    return "Radiation";
                case "TITRATION":
                    return "Titration";
                case "ULTRASOUND":
                    return "Ultrasound";
                case "RESPIRATION":
                    return "Respiration";
                case "PHOTOSYNTHESIS":
                    return "Photosynthesis";
                case "IDENTIFY_UNKNOWN_ANION":
                    return "Identify Unknown Anion";
                case "KINETIC_RATE":
                    return"Kinetic Rate";
                case "NEW_INTERFERENCE":
                   return "New Interference";
                case "CAPACITANCE":
                   return "Capacitance";
              }
            },
        },
        mounted () {
            var self = this;
            this.assignEquipmentId();
            this.getMySlots();
            this.getSlotsByDate();
            this.$ga.page('/booking/'+this.$route.params.experiment_name);
            self.labelExperiment(self.$route.params.experiment_name);
        },
        watch: {
            $route(to, from) {
                //change from one experiment to another
                var self = this;
                self.assignEquipmentId();
                self.getSlotsByDate();
            },
            "$route.params.experiment_name"(value) {
                var self = this;
                self.labelExperiment(self.$route.params.experiment_name);
            }
        },
		methods:{
            assignEquipmentId: function(){
                switch(this.$route.params.experiment_name){
                    case "interference":
                        this.experiment = "INTERFERENCE";
                    break;
                    case "visible_spectrum":
                        this.experiment = "VISIBLE_SPECTRUM";
                    break;
                    case "apparent_depth":
                        this.experiment = "APPARENT_DEPTH";
                    break;
                    case "bacteria_growth":
                        this.experiment = "BACTERIA_GROWTH";
                    break;
                    case "em_induction":
                        this.experiment = "EM_INDUCTION";
                    break;
                    case "green_house":
                        this.experiment = "GREEN_HOUSE";
                    break;
                    case "photo_electric":
                        this.experiment = "PHOTO_ELECTRIC";
                    break;
                    case "radiation":
                        this.experiment = "RADIATION";
                    break;
                    case "titration":
                        this.experiment = "TITRATION";
                    break;
                    case "ultrasound":
                        this.experiment = "ULTRASOUND";
                    break;
                    case "identify_unknown_anion":
                        this.experiment = "IDENTIFY_UNKNOWN_ANION";
                    break;
                    case "kinetic_rate":
                        this.experiment = "KINETIC_RATE";
                    break;
                    case "spectrophotometry":
                        this.experiment = "SPECTROPHOTOMETRY";
                    break;
                    case "iodine_test":
                        this.experiment = "IODINE_TEST";
                    break;                    
                    case "tensile_test":
                        this.experiment = "TENSILE_TEST";
                    break;
                    case "new_interference":
                        this.experiment = "NEW_INTERFERENCE";
                    break;
                    case "capacitance":
                        this.experiment = "CAPACITANCE";
                    break;
                }
                
            },
            isBookedByMe: function(slot){
                if(moment(slot.start_at) < moment() 
                    && slot.status == 'BOOKED' 
                    && slot.username == $cookies.get('username')){
                        return true;
                }
                else{
                    return false;
                }
            },
            isBookedByOthers: function(slot){
                if( slot.status == 'BOOKED' 
                    && slot.username != $cookies.get('username')){
                        return true;
                }
                else{
                    return false;
                }
            },
            isBookedSoon: function(slot){
                if(moment(slot.start_at) > moment() 
                    && slot.status == 'BOOKED' 
                    && slot.username == $cookies.get('username')){
                        return true;
                }
                else{
                    return false;
                }
            },
            getSlotsByDate: function(){
                var self = this;
                console.log("getSlotsByDate: " + self.current_date);
                self.api.slots = [];
                apiService.getSlotsByDate(self.experiment, self.current_date)
                .then((response) => {
                    if(typeof response.slots != 'undefined'){
                        for(var slot of response.slots){
                            if(moment(slot.end_at) < moment()){
                                slot.display = false;
                            }else{
                                slot.display = true;
                            }
                            if(slot.status == 'HOLDED'){
                                slot.display = false;
                            }
                        }
                        self.api.slots = response.slots;
                    }else{
                        alert("No Slots Assigned From Admin");
                    }
                });
            },
            bookSlot: function(slot_id){
                var self = this;
                self.$ga.event('Booking', 'book', self.$route.params.experiment_name);
                apiService.bookSlot(slot_id, self.$cookies.get('auth_token'))
                .then((response) => {
                    if(response.status == "fail"){
                        self.$store.commit('showSnackBar', response.message);
                    }else{
                        self.$store.commit('showSnackBar', "Book Success");
                        self.getSlotsByDate();
                    }
                });

            },
            releaseSlot: function(slot_id){
                var self = this;
                self.$ga.event('Booking', 'cancel', self.$route.params.experiment_name);
                apiService.releaseSlot(slot_id, self.$cookies.get('auth_token'))
                .then((response) => {
                    self.$store.commit('showSnackBar', "Booking Cancelled");
                    self.getSlotsByDate();
                });

            },
            enterLab: function(slot_id, equipment_id, role){
                var self = this;
                self.$ga.event('Booking', 'enter_lab', self.$route.params.experiment_name, role);
                apiService.enterLab(slot_id, self.$cookies.get('auth_token'),role)
                .then((response) => {
                    if(response.status == "fail"){
                        self.$store.commit('showSnackBar', response.message);
                    }else{
                        self.$store.commit('showSnackBar', "Preparing...");
                        console.log(response);
                        self.$cookies.set('session_token', response.session_token);
                        self.$cookies.set('role', role);
                        var kick_timestamp = response.end_at;
                        self.$cookies.set('kick_timestamp', kick_timestamp, Math.ceil((parseInt(kick_timestamp)*1000 - new Date().getTime())/1000));
                        self.$cookies.set('experiment', self.$route.params.experiment_name);
                        self.$cookies.set('equipment_id', equipment_id);
                        self.$router.push("/experiment/"+self.$route.params.experiment_name);

                    }
                });
            },
            getMySlots: function(){
                var self = this;
                console.log("getSlotsByDate: " + self.current_date);
                self.api.my_slots = [];
                apiService.getMySlots(self.experiment, self.current_date, self.$cookies.get('username'))
                .then((response) => {
                    if(typeof response.slots != 'undefined'){
                        for(var slot of response.slots){
                            if(moment(slot.end_at) < moment()){
                                slot.display = false;
                            }else{
                                slot.display = true;
                            }
                            if(slot.status == 'HOLDED'){
                                slot.display = false;
                            }
                        }
                        self.api.my_slots = response.slots;
                    }else{
                        //alert("No Slots Assigned From Admin");
                    }
                });
            },
            labelExperiment: function (name) {
                switch(name){
                    case 'photo_electric':
                        this.show_experiment_name = 'Photo Electric';
                    break;
                    case "interference":
                        this.show_experiment_name = "Interference";
                    break;
                    case "visible_spectrum":
                        this.show_experiment_name = "Visible Spectrum";
                    break;
                    case "apparent_depth":
                        this.show_experiment_name = "Apparent Depth";
                    break;
                    case "bacteria_growth":
                        this.show_experiment_name = "Bacteria Growth";
                    break;
                    case "em_induction":
                        this.show_experiment_name = "EM Induction";
                    break;
                    case "green_house":
                        this.show_experiment_name = "Green House";
                    break;
                    case "photo_electric":
                        this.show_experiment_name = "Photo Electric";
                    break;
                    case "radiation":
                        this.show_experiment_name = "Radiation";
                    break;
                    case "titration":
                        this.show_experiment_name = "Titration";
                    break;
                    case "ultrasound":
                        this.show_experiment_name = "Ultrasound";
                    break;
                    case "respiration":
                        this.show_experiment_name = "Respiration";
                    break;
                    case "photosynthesis":
                        this.show_experiment_name = "Photosynthesis";
                    break;
                    case "identify_unknown_anion":
                        this.show_experiment_name = "Identify Unknown Anion";
                    break;
                    case "kinetic_rate":
                        this.show_experiment_name = "Kinetic Rate";
                    break;
                    case "spectrophotometry":
                        this.show_experiment_name = "Spectrophotometry";
                    break;
                    case "iodine_test":
                        this.show_experiment_name = "Iodine Test";
                    break;
                    case "tensile_test":
                        this.show_experiment_name = "Tensile Test";
                    break;
                    case "new_interference":
                        this.show_experiment_name = "New Interference";
                    break;
                    case "capacitance":
                        this.show_experiment_name = "Capacitance";
                    break;
                }
                },
		}
	}
</script>